var angular = require('angular');
var moment = require('moment');

var storageKey = 'downtime.';

function Downtime(downtime, storage) {
  angular.extend(this, downtime);
  this.storage = storage;
}

Downtime.prototype.display = function(key) {
  if (key === 'first' || key === 'final') {
    // If no planned downtime OR if user already hidden THAT planned downtime
    if (!this.serverDownTimestamp || this.serverDownTimestamp == this.storage.local.get(storageKey+key)) return false;

    var displayFirstWarningFrom = moment(this.serverDownTimestamp).subtract(7, 'days');
    var displayFinalWarningFrom = moment(this.serverDownTimestamp).subtract(60, 'minutes');
    if (key === 'first') {
      if (moment().isAfter(displayFirstWarningFrom) && moment().isBefore(displayFinalWarningFrom)) return true;
    } else if (key === 'final') {
      if (moment().isAfter(displayFinalWarningFrom) && moment().isBefore(this.serverDownTimestamp)) return true;
    }
  } else if (key === 'general') {
    // Is a problem and user not already hidden THAT problem
    if (this.problemsTimestamp && this.problemsTimestamp !== this.storage.local.get(storageKey+key)){
      return true;
    }
  }
};

Downtime.prototype.numberOfDisplays = function(pwdWarningCheck) {
  var number = 0;
  if(pwdWarningCheck) number++;
  if(this.display('first')) number++;
  if(this.display('final')) number++;
  if(this.display('general')) number++;
  return 'display-level-' + number;
};

Downtime.prototype.formatDowntime = function(){
  return moment().to(this.serverDownTimestamp);
};

Downtime.prototype.localDowntime = function(){
    var localDowntime = moment(this.serverDownTimestamp).local()
    return moment(localDowntime).format('dddd HH:mm');
};

Downtime.prototype.getServerDownDate = function(){
  if (! this.serverDownTimestamp) return moment().format('YYYY-MM-DD');
  return moment(this.serverDownTimestamp).format('YYYY-MM-DD');
};

Downtime.prototype.getServerDownTime = function(){
  if (! this.serverDownTimestamp) return '';
  return moment(this.serverDownTimestamp).format('HH:mm');
};

Downtime.prototype.hide = function(key) {
  if (key === 'first' || key === 'final') {
    this.storage.local.set(storageKey+key, this.serverDownTimestamp);
  } else if (key === 'general') {
    this.storage.local.set(storageKey+key, this.problemsTimestamp);
  }
};

Downtime.prototype.getCleanModel = function() {
  return {
    problemsTimestamp: this.problemsTimestamp,
    serverDownTimestamp: this.serverDownTimestamp,
    estimatedDownTimeMinutes: this.estimatedDownTimeMinutes
  };
};

module.exports = Downtime;




/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/downtime.js
 ** module id = 172
 ** module chunks = 1
 **/